import React, { FC } from "react";

import { Box, Skeleton } from "@mui/material";

import CatalogueLoading from "./CatalogueLoading";

export interface IAlbumsSkeleton {
  isCollapsed?: boolean;
  isFilter?: boolean;
}

const CatalogueSkeleton: FC<IAlbumsSkeleton> = ({ isCollapsed, isFilter }) => {
  return (
    <>
      {isFilter && (
        <Box height="fit-content" gridColumn="span 12">
          <Skeleton sx={{ borderRadius: "8px" }} width="40%" height="40px" />
        </Box>
      )}
      <CatalogueLoading isCollapsed={isCollapsed} />
      <CatalogueLoading isCollapsed={isCollapsed} />
      <CatalogueLoading isCollapsed={isCollapsed} />
      <CatalogueLoading isCollapsed={isCollapsed} />
    </>
  );
};

export default CatalogueSkeleton;
